function createSwiper(slider, options = {}) {
    const defaults = {
        init: false,
        loop: true,
        on: {
            init: function () {
                slider.active = true;
            }
        }
    };

    slider.slider = new Swiper(slider.elem, Object.assign(defaults, options));
    slider.slider.init();
}

function destroySwiper(slider) {
    slider.slider.destroy();

    slider.active = false;
}

function checkSliders(slidersGroup) {
    for (const sliderName in slidersGroup) {
        checkSlider(slidersGroup[sliderName]);
    }
}

function checkSlider(slider) {
    if (!slider.elem.length) {
        return;
    }

    if (checkResolution(slider.query)) {
        if (!slider.active) {
            createSwiper(slider, slider.options);
            slider.elem.addClass('is-active');
        }
    } else {
        if (slider.active) {
            destroySwiper(slider);
            slider.elem.removeClass('is-active');
        }
    }
}

function toggleAutoplay(slider, action) {
    if (slider.active) {
        let autoplay = slider.slider.autoplay;

        if (action == 'start' && !autoplay.running) {
            autoplay.start();
        }

        if (action == 'stop' && autoplay.running) {
            autoplay.stop();
        }
    }
}
